import React from "react";
import { PawPrint } from "lucide-react";

// Scattered paw prints that gently flash in and out, like fresh prints being left.
const PAWS = [
  { top: "5%", left: "7%", size: 40, rot: -18, delay: 0.0, dur: 4.2, max: 0.6 },
  { top: "11%", left: "85%", size: 32, rot: 22, delay: 1.0, dur: 4.6, max: 0.5 },
  { top: "22%", left: "48%", size: 36, rot: 8, delay: 2.0, dur: 4.0, max: 0.45 },
  { top: "30%", left: "15%", size: 30, rot: -30, delay: 0.6, dur: 5.0, max: 0.58 },
  { top: "38%", left: "88%", size: 38, rot: 14, delay: 2.6, dur: 4.4, max: 0.5 },
  { top: "46%", left: "5%", size: 34, rot: -10, delay: 1.4, dur: 4.8, max: 0.58 },
  { top: "54%", left: "80%", size: 42, rot: 26, delay: 0.3, dur: 4.5, max: 0.5 },
  { top: "62%", left: "42%", size: 32, rot: -22, delay: 3.0, dur: 5.0, max: 0.45 },
  { top: "70%", left: "11%", size: 38, rot: 12, delay: 0.8, dur: 4.2, max: 0.58 },
  { top: "78%", left: "86%", size: 34, rot: -16, delay: 2.2, dur: 4.8, max: 0.5 },
  { top: "86%", left: "50%", size: 40, rot: 20, delay: 0.5, dur: 4.4, max: 0.55 },
  { top: "93%", left: "18%", size: 32, rot: -26, delay: 2.7, dur: 5.2, max: 0.5 },
];

export default function PawTrail() {
  return (
    <div className="paw-trail" aria-hidden="true">
      {PAWS.map((p, i) => (
        <PawPrint
          key={i}
          className="paw"
          fill="currentColor"
          style={{
            top: p.top,
            left: p.left,
            width: p.size,
            height: p.size,
            "--rot": `${p.rot}deg`,
            "--delay": `${p.delay}s`,
            "--dur": `${p.dur}s`,
            "--paw-max": p.max,
          }}
        />
      ))}
    </div>
  );
}
